export default __webpack_public_path__ + "static/media/dropdown-icon.b772dbd7.svg";